/*
 * @Author: Json Chen
 * @Date: 2021-09-27 18:49:00
 * @LastEditTime: 2022-06-15 14:12:41
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/ProductsApplyToRadioAndTable/index.tsx
 */
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import React from 'react';
import { Form, RadioGroup, RadioItem } from 'src/components/Antd';
import ProductTable from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/ProductTable';
import css from './css.module.less';

import { get } from 'lodash';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
export enum EProductType {
  Specific = 'SpecificProducts',
  All = 'AllProducts',
  NotSpecific = 'ExcludedSpecificProducts',
}
const Item = Form.Item;

const ProductsApplyToRadioAndTable = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { radioName, tableName, tableId, disableEdit, currency } = props;
  return (
    <React.Fragment>
      <ItemWrapper
        title={getI18n(
          'salesChannelDirectDiscount.discountValue.discountValueAppliesTo',
        )}>
        <Item
          name={radioName}
          rules={[{ required: true, message: 'Please select a value' }]}>
          <RadioGroup className={css.radioGroup} disabled={disableEdit}>
            <RadioItem className={css.radio} value={EProductType.All}>
              {getI18n(
                'salesChannelDirectDiscount.discountValue.applytoallproducts',
              )}
            </RadioItem>
            <RadioItem className={css.radio} value={EProductType.Specific}>
              {getI18n(
                'salesChannelDirectDiscount.discountValue.applytospecificproducts',
              )}
            </RadioItem>
            <RadioItem value={EProductType.NotSpecific}>
              {getI18n(
                'salesChannelDirectDiscount.discountValue.notapplytospecificproducts',
              )}
            </RadioItem>
          </RadioGroup>
        </Item>
      </ItemWrapper>
      <Item
        shouldUpdate={(p, c) => {
          const pV = get(p, radioName);
          const cV = get(c, radioName);
          return pV !== cV;
        }}>
        {({ getFieldValue }) => {
          const v = getFieldValue(radioName);
          const hasTable = [EProductType.Specific, EProductType.NotSpecific];
          if (hasTable.includes(v)) {
            return (
              <div className={css.tableContainer}>
                <Item
                  name={tableName}
                  rules={[
                    {
                      validator: async (x, value) => {
                        if ((value || []).length < 1) {
                          return Promise.reject(
                            new Error(
                              getI18n(
                                'general.commonRadioMulSelect.pleaseselectatleastoneitem',
                              ),
                            ),
                          );
                        }
                      },
                    },
                  ]}>
                  <ProductTable
                    currency={currency}
                    tableId={`ProductsApplyToRadioAndTable${tableId}`}
                    disableEdit={disableEdit}
                  />
                </Item>
              </div>
            );
          }
          return null;
        }}
      </Item>
    </React.Fragment>
  );
};
export default ProductsApplyToRadioAndTable;
